import React, { useEffect, useState } from "react";
import InformeLogo from "../../img/logo_aysa.png";
import "./header.css";
import { Squash as Hamburger } from "hamburger-react";
import NavBar from "../navBar/navBar";
import AppSettings from "../../settings";
import Helper from "../../helper";
import { format } from "date-fns";
import { es } from "date-fns/locale";

const Header = () => {
  const [isOpen, setOpen] = useState(false);
  const [fechaLast, setFechaLast] = useState("");

  useEffect(() => {
    const apiUrl = AppSettings.apiUrlInformeLatestFecha;
    fetch(apiUrl).then(
      (res) => {
        res.json().then((jsres) => {
          Helper.checkItemsApiResponse(jsres);
          const fechaInforme = jsres.data[0].fecha;
          const fechaFormateada = format(
            new Date(fechaInforme),
            "d 'de' MMMM HH:mm",
            { locale: es }
          );

          setFechaLast(`${fechaFormateada} hs`);
        });
      },
      (error) => {
        console.log(error);
      }
    );
  });

  return (
    <>
      <header className="u-align-left u-clearfix u-header u-section-row-container">
        <div className="u-section-rows">
          <div className="u-section-row u-white u-section-row-2">
            <div className="header">
              <div className="header__left">
                <a
                  href="/"
                  className="header__left-gohome"
                  data-image-width="194"
                  data-image-height="62"
                >
                  <img src={InformeLogo} className="header__logo"></img>
                </a>
              </div>
              <div className="header__center">
                <div className="header__informe">Informe de Prensa</div>
                <div className="header__fecha">{fechaLast}</div>
              </div>

              <div className="header__right">
                <a
                  href="https://intranet.aysa.com.ar/"
                  target="_blank"
                  className="header__intranet"
                >
                  AySA Intranet
                </a>

                <a
                  href="https://www.aysa.com.ar/usuarios/Cortes-de-servicio/Cortes_de_servicio_de_agua"
                  target="_blank"
                  className="header__interrupciones"
                >
                  Interrupciones
                </a>
              </div>
              <div className="header__hamburguer">
                <Hamburger toggled={isOpen} toggle={setOpen} size={30} />
              </div>
            </div>
          </div>
        </div>
      </header>
      {isOpen && <NavBar />}
    </>
  );
};

export default Header;

// class ButtonLink extends React.Component {
//   render() {
//     return <input type='button' className='ButtonLink'></input>;
//   }
// }
//
